import styled from 'styled-components';

export const StyledTypeResponse = styled('div')``;
